import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import api from "../../../../utils/api";
import { Card, Button } from "../components/AdminSharedComponents";

const EditClient = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    password: "",
  });

  useEffect(() => {
    const fetchClient = async () => {
      try {
        const response = await api.get(`/api/users/${id}`);
        const { name, email } = response.data.data;
        setFormData({ name, email, password: "" });
      } catch (error) {
        console.error("Error fetching client:", error);
        alert("Error fetching client data");
        navigate("/admin/client");
      }
    };

    fetchClient();
  }, [id, navigate]);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const updateData = {
        name: formData.name,
        email: formData.email,
      };

      if (formData.password) {
        updateData.password = formData.password;
      }

      await api.put(`/api/users/${id}`, updateData);
      navigate("/admin/client");
    } catch (error) {
      console.error("Error updating client:", error);
      alert(error.response?.data?.message || "Error updating client");
    }
  };

  return (
    <div className="p-6">
      <Card title="Edit Client" accentColor="primary">
        <form onSubmit={handleSubmit} className="max-w-md space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Name
            </label>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              className="w-full p-2 border rounded text-sm"
              required
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Email
            </label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              className="w-full p-2 border rounded text-sm"
              required
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Password (Leave blank to keep current password)
            </label>
            <input
              type="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              className="w-full p-2 border rounded text-sm"
            />
          </div>

          <div className="flex gap-4">
            <Button
              type="submit"
              variant="primary"
              className="flex items-center gap-1"
            >
              Update Client
            </Button>
            <Button
              type="button"
              variant="secondary"
              onClick={() => navigate("/admin/client")}
            >
              Cancel
            </Button>
          </div>
        </form>
      </Card>
    </div>
  );
};

export default EditClient;
